import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * True when SPA Entra env is set (build-time). Must match index.js wrapping MsalProvider.
 */
export function isMsalConfigured() {
  return Boolean(
    process.env.REACT_APP_ENTRA_CLIENT_ID?.trim() &&
      process.env.REACT_APP_ENTRA_TENANT_ID?.trim()
  );
}

/**
 * Single PublicClientApplication for the SPA (Entra app registration — single-page application).
 */
export function createMsalInstance() {
  const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID?.trim();
  const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID?.trim();
  if (!clientId || !tenantId) {
    return null;
  }

  // Must match Entra SPA redirect URIs exactly — no trailing slash (portal defaults omit it).
  const redirectUri = window.location.origin;

  return new PublicClientApplication({
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri,
      postLogoutRedirectUri: redirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Error,
      },
    },
  });
}
